import { serializeUrlState } from '@feat/feat-url-state/schema'
import { MAP_BASE_PATH } from '@utils/utils-config'

import type { MapUrlState } from '../hooks/use-map-url-state'

export const getMapUrl = (urlState: Partial<MapUrlState>) => {
  return `${MAP_BASE_PATH}/${serializeUrlState(urlState)}`
}
